import React, { createContext, useContext, useEffect } from 'react'
import { Table } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import styles from './asset-view.module.css'
import AssetActions from './asset-actions'
import IntelMsg from '../../../ItelMsg'

export const AssetViewContext = createContext()

const AssetView = () => {
  const { setViewAsset, assetData } = useContext(AssetViewContext)
  useEffect(() => {
    if (assetData) {
      console.log('assssset', assetData)
    }
  }, [assetData])

  const { deviceData } = useSelector((store2) => ({
    deviceData: store2.deviceData.deviceData,
  }))

  console.log(deviceData)

  const goBack = () => {
    setViewAsset(false)
  }

  const handleStatusStyle = (condition) => {
    if (condition === 'CONFIGURED') {
      return {
        color: 'blue',
      }
    }
    if (condition === 'OFFLINE') {
      return {
        color: 'red',
      }
    }
    if (condition === 'INSTALLED')
      return {
        color: 'green',
      }
    return {
      color: 'orange',
    }
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="deviceDetails" />
      </div>
      <Table definition>
        <Table.Body>
          <Table.Row>
            <Table.Cell width={3}>Name</Table.Cell>
            <Table.Cell>
              {deviceData['device label'] === '' ||
              deviceData['device label'] === null
                ? deviceData['device name']
                : deviceData['device label']}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>IMEI</Table.Cell>
            <Table.Cell>{assetData.imei}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>IMSI</Table.Cell>
            <Table.Cell>{assetData.imsi}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>SIM Number</Table.Cell>
            <Table.Cell>{assetData.simNumber}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Site Name</Table.Cell>
            <Table.Cell>
              {assetData.siteName ? (
                assetData.siteName.split(',')[1] ||
                assetData.siteName.split('_')[1] ||
                assetData.siteName
              ) : (
                <p style={{ color: 'grey' }}>No sites assigned</p>
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Device Model</Table.Cell>
            <Table.Cell>
              {assetData.deviceModel ? (
                assetData.deviceModel
              ) : (
                <p style={{ color: 'grey' }}>No device model specified</p>
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Device Status</Table.Cell>
            <Table.Cell style={handleStatusStyle(deviceData['device status'])}>
              <b>{deviceData['device status']}</b>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Warranty (Years)</Table.Cell>
            <Table.Cell>{Math.trunc(assetData.warranty)}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Delivery Date</Table.Cell>
            <Table.Cell>{assetData.deliveryDate}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>

      <AssetActions
        assetData={assetData}
        onBackClick={() => {
          goBack()
        }}
      />
    </div>
  )
}

export default AssetView
